<template>
  <div class="product">
    <headers></headers>
    <div class="product-info1">
      <img src="../assets/images/dispose/dispose1.png" alt />
    </div>
    <div class="main-top">
      <div class="product-info2">经理云 . 硬件产品</div>
      <div class="product-info3">让管理变得更轻松</div>
    </div>
    <div class="smallmain-top">
      <h2>硬件产品</h2>
    </div>

    <div class="product-info4">
      <div class="dispose-info1">
        <img src="../assets/images/dispose/dispose9.png" alt />
      </div>
      <div class="dispose-info3">
        <div class="dispose-info4">
          <img src="../assets/images/dispose/dispose8.png" alt />
        </div>
        <div class="dispose-info4">
          <img src="../assets/images/dispose/dispose7.png" alt />
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="small-info4">
      <div class="left">
        <img src="../assets/images/dispose/dispose14.png" alt />
      </div>
      <div class="right">
        <img src="../assets/images/dispose/dispose13.png" alt />
        <img src="../assets/images/dispose/dispose15.png" alt />
      </div>
    </div>

    <div class="dispose-info8"></div>
    <div class="main-top">
      <div class="product-info2">经理云 . 软件产品</div>
      <div class="product-info3">经理云让管理更加便捷有效</div>
    </div>
    <div class="smallmain-top">
      <h2>硬件产品</h2>
    </div>
    <div class="dispose-info9">
      <ul>
        <li>
          <div>
            <img src="../assets/images/dispose/dispose6.png" alt />
          </div>
          <h5>零售系统</h5>
          <p>扫码销售</p>
          <p>快捷验光</p>
          <p>会员共享</p>
          <p>库存独立和共享</p>
          <p>......</p>
          <button @click="more()">了解更多功能</button>
        </li>
        <li>
          <div>
            <img src="../assets/images/dispose/dispose3.png" alt />
          </div>
          <h5>仓库系统</h5>
          <p>分店出/退/换货</p>
          <p>厂家订/采/退/换货</p>
          <p>唯一码标签打印</p>
          <p>加工流程质检</p>
          <p>......</p>
          <button @click="more()">了解更多功能</button>
        </li>
        <li>
          <div>
            <img src="../assets/images/dispose/dispose10.png" alt />
          </div>
          <h5>微营销推广</h5>
          <p>门店专属服务号</p>
          <p>验光/销售/定制/加工</p>
          <p>会员卡/积分/兑换卡</p>
          <p>隐形眼镜过期自动提醒</p>
          <p>......</p>
          <button @click="more()">了解更多功能</button>
        </li>
      </ul>
    </div>
    <div class="dispose-info9">
      <ul>
        <li>
          <div>
            <img src="../assets/images/dispose/dispose11.png" alt />
          </div>
          <h5>微信小程序</h5>
          <p>远程录入会员/验光数据</p>
          <p>远程扫码下单</p>
          <p>扫码盘点</p>
          <p>解决所有客户堆积收银台</p>
          <p>......</p>
          <button @click="more()">了解更多功能</button>
        </li>
        <li>
          <div>
            <img src="../assets/images/dispose/dispose5.png" alt />
          </div>
          <h5>微信服务号</h5>
          <p>日营业额汇总推送</p>
          <p>退/换/修/损单据审核</p>
          <p>远程查看营业状况</p>
          <p>&nbsp;</p>
          <p>......</p>
          <button @click="more()">了解更多功能</button>
        </li>
        <li>
          <div>
            <img src="../assets/images/dispose/dispose4.png" alt />
          </div>
          <h5>店家管理后台</h5>
          <p>商品上下架/价格/库存</p>
          <p>仓库/库存/直营店</p>
          <p>上下游/供应商/对应价格</p>
          <p>商品销售/员工业绩/会员</p>
          <p>......</p>
          <button @click="more()">了解更多功能</button>
        </li>
      </ul>
    </div>
    <!-- 移动端 -->
    <div class="small-info9">
      <div class="info9-left">
        <ul>
          <li>
            <div>
              <img src="../assets/images/dispose/dispose6.png" alt />
            </div>
            <h5>零售系统</h5>
            <p>扫码销售</p>
            <p>快捷验光</p>
            <p>会员共享</p>
            <p>库存独立和共享</p>
            <p>......</p>
            <button @click="more()">了解更多功能</button>
          </li>
          <li>
            <div>
              <img src="../assets/images/dispose/dispose3.png" alt />
            </div>
            <h5>仓库系统</h5>
            <p>分店出/退/换货</p>
            <p>厂家订/采/退/换货</p>
            <p>唯一码标签打印</p>
            <p>加工流程质检</p>
            <p>......</p>
            <button @click="more()">了解更多功能</button>
          </li>
          <li>
            <div>
              <img src="../assets/images/dispose/dispose10.png" alt />
            </div>
            <h5>微营销推广</h5>
            <p>门店专属服务号</p>
            <p>验光/销售/定制/加工</p>
            <p>会员卡/积分/兑换卡</p>
            <p>隐形眼镜过期自动提醒</p>
            <p>......</p>
            <button @click="more()">了解更多功能</button>
          </li>
        </ul>
      </div>
      <div class="info9-right">
        <ul>
          <li>
            <div>
              <img src="../assets/images/dispose/dispose11.png" alt />
            </div>
            <h5>微信小程序</h5>
            <p>远程录入会员/验光数据</p>
            <p>远程扫码下单</p>
            <p>扫码盘点</p>
            <p>解决所有客户堆积收银台</p>
            <p>......</p>
            <button @click="more()">了解更多功能</button>
          </li>
          <li>
            <div>
              <img src="../assets/images/dispose/dispose5.png" alt />
            </div>
            <h5>微信服务号</h5>
            <p>日营业额汇总推送</p>
            <p>退/换/修/损单据审核</p>
            <p>远程查看营业状况</p>
            <p>&nbsp;</p>
            <p>......</p>
            <button @click="more()">了解更多功能</button>
          </li>
          <li>
            <div>
              <img src="../assets/images/dispose/dispose4.png" alt />
            </div>
            <h5>店家管理后台</h5>
            <p>商品上下架/价格/库存</p>
            <p>仓库/库存/直营店</p>
            <p>上下游/供应商/对应价格</p>
            <p>商品销售/员工业绩/会员</p>
            <p>......</p>
            <button @click="more()">了解更多功能</button>
          </li>
        </ul>
      </div>
    </div>

    <div class="dispose-info8"></div>
    <div class="main-top">
      <div class="product-info2">自配产品</div>
      <div class="product-info3">为眼镜行业专业定制</div>
    </div>
    <div class="smallmain-top">
      <h2>硬件产品</h2>
    </div>
    <div class="dispose-info10">
      <div class="dispose-info11">
        <img src="../assets/images/dispose/dispose2.png" width="100%" alt />
      </div>
      <div class="dispose-info11">
        <img src="../assets/images/dispose/11.png" width="100%" alt />
      </div>
    </div>
    <!-- 移动端 -->
    <div class="small-info10">
      <img src="../assets/images/dispose/dispose2.png" width="100%" alt />
       <img src="../assets/images/dispose/11.png" width="100%" alt />
    </div>
    <footers></footers>
  </div>
</template>

<script>
import footer from "../components/footer";
import header from "../components/headers";

export default {
  name: "",
  components: {
    footers: footer,
    headers: header
  },
  data() {
    return {};
  },

  methods: {
    more() {
      this.$router.push({ path: "/VersionControlTable" });
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}
.product {
  width: 100%;
  @media screen and (max-width: 850px) {
    .main-top {
      display: none;
    }
    .product-info4 {
      display: none !important;
    }
    .dispose-info9 {
      display: none;
    }
    .dispose-info10{
      display: none !important;
    }
  }
  @media screen and (min-width: 850px) {
    .smallmain-top {
      display: none;
    }
    .small-info4 {
      display: none;
    }
    .small-info9 {
      display: none;
    }
    .small-info10{
      display: none;
    }
  }
  .smallmain-top {
    h2 {
      font-size: 16px;
      color: #2e2e2e;
      font-weight: 400;
      margin: 11px 0;
      position: relative;
      padding-left: 28px;

      &::after {
        content: "";
        background-color: #258ffc;
        border-radius: 5.5px;
        width: 4px;
        height: 16px;
        overflow: hidden;
        position: absolute;
        top: 3px;
        left: 15px;
      }
    }
  }

  .product-info1 {
    width: 100%;
    // height:580px;
    margin-bottom: 60px;
    img {
      width: 100%;
      height: 100%;
    }
    @media screen and (max-width: 850px) {
      margin-bottom: 20px;
    }
  }
  .product-info2 {
    width: 30%;
    font-size: 28px;
    font-family: MicrosoftYaHei;
    font-weight: bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
  }
  .product-info3 {
    width: 30%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    // font-weight: bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    margin-top: 19px;
  }
  .product-info4 {
    width: 58%;
    height: 700px;
    margin: 0 auto;
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    min-width: 1100px;
    .dispose-info1 {
      width: 48%;
      height: 700px;
      background: #f5f5f5;
      .dispose-info2 {
        width: 70%;
        height: 55%;
        margin: 40px 0 0 60px;
        // border:1px dashed #999;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .dispose-info3 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .dispose-info4 {
        width: 100%;
        height: 340px;
        background: #f5f5f5;
        // border:1px dashed #999;
        display: flex;
        justify-content: space-around;
        .dispose-info6 {
          width: 83px;
          height: 92px;
          // border:1px dashed #999;
          margin: 50px 0 0 50px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .dispose-info66 {
          width: 140px;
          height: 85px;
          // border:1px dashed #999;
          margin: 50px 0 0 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .dispose-info7 {
          margin: 50px 0 0 0;
          p {
            width: 100%;
            text-align: center;
            font-size: 9px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: rgba(50, 50, 50, 1);
            line-height: 30px;
          }
        }
      }
    }
  }
  .small-info4 {
    width: 100%;
    padding: 0 15px;
    overflow: hidden;
    margin-bottom: 20px;
    .left {
      float: left;
      width: 48%;
      img {
        width: 100%;
      }
    }
    .right {
      float: right;
      width: 48%;
      img {
        width: 100%;
        &:nth-of-type(1) {
          margin-bottom: 5px;
        }
      }
    }
  }
  .dispose-info8 {
    width: 55%;
    height: 1.5px;
    background: rgba(67, 139, 237, 1);
    margin: 80px auto 40px auto;
    opacity: 0.3;
    @media screen and (max-width: 850px) {
      display: none;
    }
  }
  .dispose-info9 {
    width: 57%;
    height: 462px;
    margin: 0 auto;
    margin-top: 50px;
    min-width: 1080px;
    ul {
      width: 100%;
      display: flex;
      justify-content: space-between;
      li {
        width: 30%;
        height: 426px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid #bdddfe;
        border-radius: 2px;
        box-shadow: 0px 4px 10px 0px #f0f4fd;
        div {
          width: 58px;
          height: 58px;
          margin: 0 auto;
          margin-top: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        h5 {
          text-align: center;
          //   line-height: 40px;
          font-size: 20px;
          margin: 22px 0 29px 0;
        }
        p {
          font-size: 16px;
          line-height: 25px;
          text-align: center;
          opacity: 0.6;
        }
        button {
          width: 47%;
          height: 50px;
          line-height: 30px;
          font-size: 16px;
          text-align: center;
          position: relative;
          left: 50%;
          margin-left: -22.5%;
          bottom: -45px;
          background: rgba(37, 143, 252, 1);
          color: rgba(255, 255, 255, 1);
          border: 1px solid rgba(37, 143, 252, 1);
          box-shadow: 0px 4px 10px 0px #f0f4fd;
          border-radius: 2px;
          cursor: pointer;
          &:hover {
            background-color: #4ea6ff;
          }
        }
        &:hover {
          transform: scale(1.02);
          transition: all 0.2s linear;
        }
      }
    }
  }
  .small-info9 {
    width: 100%;
    padding: 0 15px;
    overflow: hidden;
    .info9-left {
      width: 48%;
      float: left;
    }
    .info9-right {
      width: 48%;
      float: right;
    }
    .info9-left,
    .info9-right {
      ul {
        li {
          text-align: center;
          border-radius: 3px;
          border: 1px solid #258ffc;
          box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2);
          // height: 212px;
          padding:20px 0; 
          margin-bottom: 17px;
          img {
            width: 32px;
            height: 28px;
          }
          h5{
            font-size: 12px;
            margin: 7px 0;
          }
          p{
            font-size: 11px;
          }
          button{
            outline: none;
            border: 0;
            width: 75px;
            height: 25px;
            background-color: #258ffc;
            border-radius: 4px;
            font-size: 9px;
            margin-top: 18px;
          }
        }
      }
    }
  }
  .dispose-info10 {
    width: 63%;
    height: 400px;
    margin: 0 auto;
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 239px;
    min-width: 900px;
    .dispose-info11 {
      width: 48%;
      height: 380px;
    }
  }
  .small-info10{
    width: 100%;
    padding: 0 15px;
    img{
      margin: 9px 0;
      &:nth-last-of-type(1){
        margin-bottom: 70px;
      }
    }
  }
}
</style>
